module.exports = __webpack_public_path__ + "static/media/Monolith_Video_No_Zoom_No_Logo.25a76b6e.mp4";